// Content-type routing (spec section 70): the record stays generic, the URL prefix varies by type.
export const CONTENT_TYPES = {
  blog: { route: 'blog', label: 'Blog' },
  article: { route: 'articles', label: 'Article' },
  'case-study': { route: 'case-studies', label: 'Case study' },
  product: { route: 'products', label: 'Product' },
  service: { route: 'services', label: 'Service' },
  'technical-document': { route: 'docs', label: 'Technical document' },
  news: { route: 'news', label: 'News' },
  project: { route: 'projects', label: 'Project' },
  'landing-page': { route: 'pages', label: 'Page' },
};

export function typeInfo(type) {
  return CONTENT_TYPES[type] || { route: type, label: type };
}

export function contentPath(entry) {
  return `/${typeInfo(entry.type).route}/${entry.slug}`;
}

export function formatDate(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
}
